import './SignUpAddPage.css'
import { useEffect, useRef, useState } from 'react'
import { AlertMessage, DcsPermissions, IParamsType, IRootState } from 'types'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
    AddButton,
    SaveButton,
} from 'components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form, FormElement } from '@progress/kendo-react-form'
import { Badge, Col, Row } from 'react-bootstrap'
import { DEFAULT_PERMISSION_MESSAGE, LS_SIDEBAR_MENU_STATE } from 'core/consts'
import { isMobile } from 'react-device-detect'
import { focusFirstError, getErrors } from 'core/helpers'
import { Switch, TextBox } from '@progress/kendo-react-inputs'
import { Label } from '@progress/kendo-react-labels'
import { DropDownList } from '@progress/kendo-react-dropdowns'
const SignUpAddPage = () => {

    // Temp dropdown data
    const salespeople = ['Salesperson 1', 'Salesperson 2', 'Salesperson 3']
    const countries = ['USA', 'Canada']

    const hasEditInventoryPermission = true// hasPermission(DcsPermissions.EditInventory)

    const editable = hasEditInventoryPermission


    return (
        <div id='SignUpAddPage'>
            <div className='row p-2 mt-2'>
                <div className='col-md-4' style={{ alignSelf: 'center' }}>
                    <span className='pageHeader'>
                        <h3>Sign Up - Add</h3>
                    </span>
                </div>
                <div className='col-md-8 text-md-end text-start mt-2 mt-lg-0' style={{ alignSelf: 'center' }}>
                </div>
            </div>
            <div className='section-divider'></div>
            <Form
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <div id='LeadInformationForm'>
                            <div className='bg-light shadow-sm p-3 border pb-5'>
                                <Row>
                                    <Col xs={12}>
                                        <Label>Returning Dealer?</Label>{' '}
                                        <Switch onLabel='Yes' offLabel='No' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Salesperson:</Label>
                                        <DropDownList
                                            data={salespeople}
                                            defaultValue='Salesperson 1'
                                            className='form-control'
                                        />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Company Name:</Label>
                                        <TextBox name='companyname' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Dealer Principal First Name:</Label>
                                        <TextBox name='dealerprincipalfirstname' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Dealer Principal Last Name:</Label>
                                        <TextBox name='dealerprincipallastname' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Principal Email:</Label>
                                        <TextBox name='principalemail' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Principal Phone:</Label>
                                        <TextBox name='principalphone' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Primary Contact First Name:</Label>
                                        <TextBox name='primarycontactfirstname' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Primary Contact Last Name:</Label>
                                        <TextBox name='primarycontactlastname' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Primary Email:</Label>
                                        <TextBox name='primaryemail' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Address 1:</Label>
                                        <TextBox name='address1' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Address 2:</Label>
                                        <TextBox name='address2' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>City:</Label>
                                        <TextBox name='city' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>State:</Label>
                                        <TextBox name='state' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Zip:</Label>
                                        <TextBox name='zip' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>City:</Label>
                                        <TextBox name='city' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Country:</Label>
                                        <DropDownList
                                            data={countries}
                                            defaultValue='USA'
                                            className='form-control'
                                        />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Phone:</Label>
                                        <TextBox name='phone' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Fax:</Label>
                                        <TextBox name='fax' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Mobile Phone:</Label>
                                        <TextBox name='mobilephone' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Toll Free Phone:</Label>
                                        <TextBox name='tollfreephone' className='form-control' type='text' />
                                    </Col>
                                    <Col lg={3} md={4}>
                                        <Label>Website:</Label>
                                        <TextBox name='website' className='form-control' type='text' />
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <Row className='my-4'>
                            <Col xs={12} sm={4}>
                                <AddButton
                                    title={!editable ? DEFAULT_PERMISSION_MESSAGE : undefined}
                                    onClick={() => focusFirstError(formRenderProps)}
                                    type='submit' />
                            </Col>
                        </Row>
                    </FormElement>
                )
                }
            />
        </div>
    )
}
export default SignUpAddPage